import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import moment from "moment";
import { FinancealYearStartDateEndDate } from "../../utils/FinancialYearStartDateEndDate.js";

class AdditionalEntry extends Component {
  constructor(props) {
    super(props);
    this.inventoryServices = new InventoryServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isGridView: true,
      isMaterialDetailsHide: true,
      tableStatus: "",
      isLoading: false,
      totalStock: 0,
      isMaterialDetailsEditing: false,
      isEditing: false,
      productionMaterialDetailsList: [],
      additionalEntryList: [],
      companyItemList: [],
      productionDetailId: '',
      productionMaterialDetailId: '',
      productionRequisitionEntry: {
        reqDate: '',
        type: '',
        batchNo: '',
        batchSize: '',
        productName: '',
        materialType: '',
        itemId: '',
      },
      productionRequisitionMaterialDetails: {
        rawMaterialId: '',
        packageMaterialId: '',
        MaterialDetails: "",
        qty: 0,
        uom: ''
      },
      filterDetails: {
        productName: '',
        filterBy: '',
        materialType: ''
      },
      rawMaterialList: [],
      packingMaterialDropDownList: [],
      filterByList: [
        { filterBy: 'Slip No', value: 'slipNo' },
        { filterBy: 'Date', value: 'reqDate' },
        { filterBy: 'Batch No', value: 'batchNo' },
        { filterBy: 'Product Name', value: 'productName' }
      ],
      additionTypes: [
        { type: 'ADDITIONAL' },
        { type: 'SHORTAGE' },
        { type: 'WASTAGE' },
        { type: 'OTHER' }
      ],
      typeList: [
        { grnType: 'Raw' },
        { grnType: 'Packing' },
      ],
      validationRules: {
        reqDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "request date"
            ),
          },
        ],
        type: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "type"
            ),
          },
        ],
        // productName: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "product name"
        //     ),
        //   },
        // ],
        materialType: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "material type"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRulesForMaterials: {
        qty: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "qty"
            ),
          },
        ],
      },
      rawMaterialIdRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "raw material"
          ),
        },
      ],
      packageMaterialIdRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "package material"
          ),
        },
      ],
      validStateForMaterials: {
        isValid: true,
        error: {},
      },
    };
  }

  componentDidMount() {
    let dates = FinancealYearStartDateEndDate()
    let filterDetails = this.state.productionRequisitionEntry
    filterDetails.reqDate = dates.endDate
    this.setState({ filterDetails: filterDetails })
    this.getAllAdditionalEntryList()
  }


  getAllAdditionalEntryList = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails
    this.inventoryServices.getAllAdditionalEntryList(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        let res = response.responseData;
        this.setState({ additionalEntryList: res }, () => {
          this.getAllRMDropdown()
        });
      } else {
        this.setState({ tableStatus: "" })
        this.getAllRMDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllRMDropdown = () => {
    this.commonServices.getAllRMDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmName,
          value: item._id,
          uom: item.rmUOM
        }));
        this.setState({ rawMaterialList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown()
        });
      } else {
        this.getAllPackingMaterialDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM
        }));
        this.setState({ packingMaterialDropDownList: dropdownItems }, () => {
          this.getAllItem()
        });
      } else {
        this.SwalServices.Error(response.Message);
        this.getAllItem()
      }
    });
  };

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
          packing: item.Packing,
        }));
        this.setState({ companyItemList: dropdownItems }, () => {
        });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.setState({ isGridView: true, isEditing: false });
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    let details = this.state.productionRequisitionEntry;
    let details1 = this.state.productionRequisitionMaterialDetails
    let detials2 = this.state.filterDetails
    if (section === "MaterialDetails") {
      details1[name] = value.toUpperCase();
      this.setState({ productionRequisitionMaterialDetails: details1 }, () => {
        this.isAllFieldsValidate()
      });
    } else if (section === "FilterDetails") {
      detials2[name] = value.toUpperCase();
      this.setState({ filterDetails: detials2 }, () => {
        this.getAllAdditionalEntryList()
      });
    } else {
      details[name] = value.toUpperCase();
      this.setState({ productionRequisitionEntry: details }, () => {
        this.isAllFieldsValidate()
      });
    }
  };

  handleDropdownChange = (e, name, section) => {
    const value = e.target.value;
    if (section === "FilterDetails") {
      let details = this.state.filterDetails;
      details[name] = value;
      this.setState({ filterDetails: details }, () => {
        this.getAllAdditionalEntryList()
      });
    } else {
      let details = this.state.productionRequisitionEntry;
      details[name] = value;
      this.setState({ productionRequisitionEntry: details }, () => {
        this.isAllFieldsValidate()
      });
    }
  };

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.productionRequisitionEntry,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    if (newValidState.isValid) {
      this.setState({ isMaterialDetailsHide: false })
    } else {
      this.setState({ isMaterialDetailsHide: true })
    }
  }

  setFilterParameters = (selected, drpIdentity, section) => {
    let details = this.state.productionRequisitionEntry
    let details1 = this.state.productionRequisitionMaterialDetails
    if (section === 'grnMaterialDetails') {
      details[drpIdentity] = selected.value
      this.setState({ productionRequisitionEntry: details }, () => {
        this.isAllFieldsValidate()
      });
    }
    if (section === 'MaterialDetails') {
      details1[drpIdentity] = selected.value
      details1.uom = selected.uom
      if (drpIdentity === 'rawMaterialId') {
        let item = {
          _id: selected.value,
          rmName: selected.label
        }
        this.getAllStatementForPurchaseItemByItemId(item, 'Raw Material')
      } else if (drpIdentity === 'packageMaterialId') {
        let item = {
          _id: selected.value,
          pmName: selected.label
        }
        this.getAllStatementForPurchaseItemByItemId(item, 'Packing Material')
      }
      this.setState({ productionRequisitionMaterialDetails: details1 });
    }
  };

  getAllStatementForPurchaseItemByItemId = (item, materialType) => {
    let request = {
      item: item,
      materialType: materialType,
    };
    this.inventoryServices
      .getAllStatementForPurchaseItemByItemId(request)
      .then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          let details = response.responseData;
          const totalStock = details.totalStock
          this.setState({ totalStock: totalStock });
        }
      });
  };

  addEditAdditionalEntryMaterialMapping = () => {
    let isValidAllFields = this.isValidAllFields()
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = {};
        request.productionRequisitionEntry = this.state.productionRequisitionEntry
        request.productionRequisitionMaterialDetails = this.state.productionRequisitionMaterialDetails

        if (this.state.productionRequisitionEntry.materialType === 'Raw') {
          delete request.productionRequisitionMaterialDetails.packageMaterialId
        } else {
          delete request.productionRequisitionMaterialDetails.rawMaterialId
        }

        if (this.state.productionDetailId && this.state.productionDetailId !== "") {
          request.productionRequisitionEntry.productionDetailId = this.state.productionDetailId;
        } else {
          delete request.productionRequisitionEntry.productionDetailId;
        }

        if (this.state.productionMaterialDetailId && this.state.productionMaterialDetailId !== "") {
          request.productionRequisitionMaterialDetails.productionMaterialDetailId = this.state.productionMaterialDetailId;
        } else {
          delete request.productionRequisitionMaterialDetails.productionMaterialDetailId;
        }

        this.inventoryServices.addEditAdditionalEntryMaterialMapping(request).then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.SwalServices.Success(response.Message)
            this.setState({ productionDetailId: response.responseData.productionRequisitionDetails._id }, () => {
              this.SwalServices.Success(response.Message)
              this.resetMaterialDetalis()
              this.getAllAdditionalEntryMaterialDetailsById(this.state.productionDetailId)
              this.setState({ isLoading: false })
            })
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        })
      })
    }
  }

  isValidAllFields = () => {
    const validationRule = this.state.validationRulesForMaterials
    if (this.state.productionRequisitionEntry.materialType === 'Raw') {
      validationRule.rawMaterialId = this.state.rawMaterialIdRule
      validationRule.packingMaterialId = []
    } else {
      validationRule.packageMaterialId = this.state.packageMaterialIdRule
      validationRule.rawMaterialId = []
    }
    const newValidState = isValidForm(
      this.state.productionRequisitionMaterialDetails,
      validationRule,
      this.state.validStateForMaterials
    );
    this.setState({ validStateForMaterials: newValidState });
    return newValidState.isValid;
  };

  setFilterParametersForItemTable = (selected, fieldName) => {
    let details = this.state.productionRequisitionEntry;
    details[fieldName] = selected.value;
    if (fieldName === 'itemId') {
      details.packing = selected.packing
      details.productName = selected.label
    }
    this.setState({ itemDetails: details }, () => {
      this.isAllFieldsValidate()
    });
  };

  resetFilterDetails = () => {
    let filterDetails = this.state.filterDetails
    filterDetails.productName = ""
    filterDetails.filterBy = ""
    filterDetails.materialType = ""
    this.setState({ filterDetails: filterDetails })
  }
  resetMaterialDetalis = () => {
    let validState = this.state.validStateForMaterials
    validState.isValid = true
    validState.error = {}
    let details = this.state.productionRequisitionMaterialDetails
    details.rawMaterialId = ""
    details.packageMaterialId = ""
    details.MaterialDetails = ''
    details.qty = 0
    details.uom = ''
    this.setState({ productionRequisitionMaterialDetails: details, isMaterialDetailsEditing: false, validState: validState, productionMaterialDetailId: '' })
  }

  resetPartyDetails = () => {
    let details = this.state.productionRequisitionEntry
    details.reqDate = ''
    details.type = ''
    details.batchNo = ''
    details.batchSize = ''
    details.productName = ''
    details.materialType = ''
    this.setState({ productionRequisitionEntry: details, productionDetailId: '', productionMaterialDetailsList: [], })
  }
  resetFormAndOpenGrid = () => {
    this.resetFilterDetails()
    this.resetMaterialDetalis()
    this.resetPartyDetails()
    this.setState({ isGridView: true, isMaterialDetailsHide: true, isEditing: false, tableStatus: "" }, () => {
      this.getAllAdditionalEntryList()
    })
  }


  getAllAdditionalEntryMaterialDetailsById = (id) => {
    this.inventoryServices.getAllAdditionalEntryMaterialDetailsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        this.setState({ productionMaterialDetailsList: details }, () => {
          this.isAllFieldsValidate()
          this.setState({ isGridView: false, isEditing: true })
        })
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  }

  getAdditionEntryDetailsById = (materialDetails) => {
    let details = this.state.productionRequisitionEntry
    details.reqDate = moment(materialDetails.reqDate).format('yyyy-MM-DD')
    details.type = materialDetails.type
    details.batchNo = materialDetails.batchNo
    details.batchSize = materialDetails.batchSize
    details.productName = materialDetails.productName
    details.materialType = materialDetails.materialType
    this.setState({ productionRequisitionEntry: details, productionDetailId: materialDetails._id }, () => {
      this.getAllAdditionalEntryMaterialDetailsById(materialDetails._id)
    })
  }

  deleteAdditionalEntryDetailsById = (id) => {
    this.inventoryServices.deleteAdditionalEntryDetailsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.getAllAdditionalEntryList()
        this.SwalServices.Success(response.Message);
      } else {
        this.SwalServices.Error(response.Message);
      }
    })
  }

  getMaterialDetailsById = (materialDetail) => {
    let details = this.state.productionRequisitionMaterialDetails
    details.rawMaterialId = materialDetail.rawMaterialId ? materialDetail.rawMaterialId._id : ''
    details.packageMaterialId = materialDetail.packageMaterialId ? materialDetail.packageMaterialId._id : ''
    details.qty = materialDetail.qty
    details.uom = this.state.productionRequisitionEntry.materialType === 'Raw' ? materialDetail.rawMaterialId.rmUOM : materialDetail.packageMaterialId.pmUOM
    this.setState({ productionRequisitionMaterialDetails: details, productionMaterialDetailId: materialDetail._id }, () => {
      this.setState({ isMaterialDetailsEditing: true })
    })
  }

  deleteAdditionalEntryMaterialDetailsById = (id) => {
    this.inventoryServices.deleteAdditionalEntryMaterialDetailsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.getAllAdditionalEntryMaterialDetailsById(this.state.productionDetailId)
        this.SwalServices.Success(response.Message);
      } else {
        this.SwalServices.Error(response.Message);
      }
    })
  }

  render() {
    return (
      <div className="additionalEntry-page">
        {this.state.isGridView === true ? (
          <>
            <div className="item-search mb-3.5">
              <div className="item-grp !flex !gap-2.5 mb-3.5">
                <div className="search-grp !w-[60%]">
                  <div className="item-search-box ">
                    <label>Product Name</label>
                    <input
                      className="inputFocus"
                      type="text"
                      id="productName"
                      name="productName"
                      autoComplete="off"
                      value={this.state.filterDetails.productName}
                      onChange={(event) =>
                        this.handleChange(event, "productName", "FilterDetails")
                      }
                    />
                  </div>
                </div>
                <div className="dropdown-grp !w-[20%]">
                  <label>Filter by</label>
                  <select
                    value={this.state.filterDetails.filterBy}
                    onChange={(e) =>
                      this.handleDropdownChange(e, "filterBy", "FilterDetails")
                    }
                  >
                    <option>Select</option>
                    {this.state.filterByList.map((x, key) => (
                      <option key={key} value={x.value}>
                        {x.filterBy}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="dropdown-grp !w-[20%]">
                  <label>Material type</label>
                  <select
                    value={this.state.filterDetails.materialType}
                    onChange={(e) =>
                      this.handleDropdownChange(e, "materialType", "FilterDetails")
                    }
                  >
                    <option>Select</option>
                    {this.state.typeList.map((x, key) => (
                      <option key={key} value={x.grnType}>
                        {x.grnType}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <button className="add-btn" onClick={() => this.closeGridView()}>
                Add new Item
              </button>
            </div>
            <div className="itemList-table">
              <div className="table-container " style={{ height: "calc(100vh - 180px)" }} >
                <table className="itemList">
                  <thead>
                    <tr>
                      <td style={{ width: "10%" }}>Slip No</td>
                      <td style={{ width: "12%" }}>Req. Date</td>
                      <td style={{ width: "13%" }}>Batch No</td>
                      <td style={{ width: "42%" }}>Product Name</td>
                      <td style={{ width: "13%" }}>Material Type</td>
                      <td style={{ width: "10%", textAlign: 'center' }}>Action</td>
                    </tr>
                  </thead>
                  {this.state.additionalEntryList && this.state.additionalEntryList.length > 0 ? (
                    this.state.additionalEntryList.map((item, key) => (
                      <tbody key={key}>
                        <tr>
                          <td>{item.slipNo}</td>
                          <td>{moment(item.reqDate).format('DD MMM yyyy')}</td>
                          <td>{item.batchNo}</td>
                          <td>{item.productName}</td>
                          <td>{item.materialType}</td>
                          <td style={{ textAlign: "center" }}>
                            <button
                              className="search-btn"
                              onClick={() => this.getAdditionEntryDetailsById(item)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </button>
                            <button
                              className="cancel-btn"
                              onClick={() =>
                                this.deleteAdditionalEntryDetailsById(item._id)
                              }
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    ))
                  ) : this.state.additionalEntryList &&
                    this.state.additionalEntryList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.additionalEntryList &&
                    this.state.additionalEntryList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </table>
              </div>
            </div>
          </>
        ) : null}
        {this.state.isGridView === false ? (
          <div className="item-listing">
            <div className="item-form">
              <div className="form-table">
                <div className="item-grp mb-3">
                  <div className="text-lg font-bold mb-[10px] text-gray-700">
                    Production Requisition Entry
                  </div>
                  <div className="item-inner-grp flex gap-2.5">
                    <div className="input-grp  !w-full">
                      <label>Req. Date</label>
                      <input
                        type="date"
                        id="reqDate"
                        name="reqDate"
                        autoComplete="off"
                        className="inputFocus"
                        // className={`inputFocus ${this.state.isEditing ? 'disable-input' : ''}`}
                        disabled={this.state.isEditing}
                        value={this.state.productionRequisitionEntry.reqDate}
                        onChange={(event) =>
                          this.handleChange(event, "reqDate")
                        }
                      />
                    </div>
                    <div className="input-grp  !w-full">
                      <label>Type</label>
                      <select
                        name="type"
                        value={this.state.productionRequisitionEntry.type}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "type")
                        }
                        className="inputFocus"
                        // className={`${this.state.isEditing ? 'disable-input' : ''}`}
                        disabled={this.state.isEditing}
                      >
                        <option>Select</option>
                        {this.state.additionTypes &&
                          this.state.additionTypes.length > 0 &&
                          this.state.additionTypes.map((x, key) => (
                            <option>{x.type}</option>
                          ))}
                      </select>
                    </div>
                    <div className="input-grp !w-full">
                      <label>Batch No</label>
                      <input
                        type="text"
                        id="batchNo"
                        name="batchNo"
                        autoComplete="off"
                        className="inputFocus"
                        // className={`inputFocus ${this.state.isEditing ? 'disable-input' : ''}`}
                        disabled={this.state.isEditing}
                        value={this.state.productionRequisitionEntry.batchNo}
                        onChange={(event) =>
                          this.handleChange(event, "batchNo")
                        }
                      />
                    </div>
                    <div className="input-grp !w-full">
                      <label>Batch Size</label>
                      <input
                        type="text"
                        id="batchSize"
                        name="batchSize"
                        autoComplete="off"
                        className="inputFocus"
                        // className={`inputFocus ${this.state.isEditing ? 'disable-input' : ''}`}
                        disabled={this.state.isEditing}
                        value={this.state.productionRequisitionEntry.batchSize}
                        onChange={(event) =>
                          this.handleChange(event, "batchSize")
                        }
                      />
                    </div>
                    <div className="input-grp !min-w-[25%]"  >
                      <label>Product Name</label>
                      <MultiSelectDropdown
                        drpIdentity="itemId"
                        options={this.state.companyItemList}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        isDisabled={this.state.isEditing}
                        onChange={(selected) =>
                          this.setFilterParametersForItemTable(
                            selected,
                            "itemId"
                          )
                        }
                        allowSelectAll={false}
                        value={this.state.companyItemList.filter(
                          (party) => party.label === this.state.productionRequisitionEntry.productName
                        )}
                      />
                      <ValidationText error={this.state.validState.error.itemId} />
                    </div>
                    <div className="dropdown-grp  !w-full">
                      <label>Material Type</label>
                      <select
                        name="materialType"
                        disabled={this.state.isEditing}
                        // className={`${this.state.isEditing ? 'disable-input' : ''}`}
                        value={this.state.productionRequisitionEntry.materialType}
                        onChange={(e) =>
                          this.handleDropdownChange(e, "materialType")
                        }
                      >
                        <option>Select</option>
                        {this.state.typeList.map((x, key) => (
                          <option key={key} value={x.grnType}>
                            {x.grnType}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="item-grp mt-2">
                  <div className="text-lg font-bold mb-[10px] text-gray-700">
                    Material Details
                  </div>
                  <div className="item-inner-grp !flex gap-2.5">
                    <div className="input-grp">
                      <label>Material Name</label>
                      {this.state.productionRequisitionEntry.materialType === 'Raw' ?
                        <>
                          <MultiSelectDropdown
                            className={` ${this.state.validStateForMaterials?.error?.rawMaterialId ? "errorInput" : ""}`}
                            drpIdentity="rawMaterialId"
                            options={this.state.rawMaterialList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                              this.setFilterParameters(selected, "rawMaterialId", "MaterialDetails")
                            }
                            allowSelectAll={false}
                            value={this.state.rawMaterialList.filter(
                              (party) =>
                                party.value === this.state.productionRequisitionMaterialDetails.rawMaterialId
                            )}
                            isDisabled={this.state.isMaterialDetailsHide}
                          />
                          {/* <ValidationText
                            error={this.state.validStateForMaterials.error.rawMaterialId}
                          /> */}
                        </>
                        :
                        <>
                          <MultiSelectDropdown
                            className={` ${this.state.validStateForMaterials?.error?.packageMaterialId ? "errorInput" : ""}`}
                            drpIdentity="packageMaterialId"
                            options={this.state.packingMaterialDropDownList}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            onChange={(selected) =>
                              this.setFilterParameters(selected, "packageMaterialId", "MaterialDetails")
                            }
                            allowSelectAll={false}
                            value={this.state.packingMaterialDropDownList.filter(
                              (party) =>
                                party.value === this.state.productionRequisitionMaterialDetails.packageMaterialId
                            )}
                            isDisabled={this.state.isMaterialDetailsHide}
                          />
                          {/* <ValidationText
                            error={this.state.validStateForMaterials.error.packageMaterialId}
                          /> */}
                        </>
                      }
                    </div>
                    <div className="input-grp !w-[20%]">
                      <label>Quantity</label>
                      <input
                        className={`inputFocus ${this.state.validStateForMaterials?.error?.qty ? "errorInput" : ""}`}
                        type="number"
                        id="qty"
                        name="qty"
                        autoComplete="off"
                        disabled={this.state.isMaterialDetailsHide}
                        // className={`inputFocus ${this.state.isMaterialDetailsHide ? 'disable-input' : ''}`}
                        value={this.state.productionRequisitionMaterialDetails.qty}
                        onChange={(event) =>
                          this.handleChange(event, "qty", "MaterialDetails")
                        }
                      />
                      {/* <ValidationText
                        error={this.state.validStateForMaterials.error.qty}
                      /> */}
                    </div>

                    <div className="input-grp !w-[10%]">
                      <label>UOM</label>
                      <input
                        type="text"
                        id="uom"
                        name="uom"
                        autoComplete="off"
                        disabled
                        className="inputFocus"
                        value={this.state.productionRequisitionMaterialDetails.uom}
                        onChange={(event) =>
                          this.handleChange(event, "uom", "MaterialDetails")
                        }
                      />

                    </div>
                    <div className="input-grp !w-[10%]">
                      <label>Stock</label>
                      <input
                        type="text"
                        id="totalStock"
                        name="totalStock"
                        autoComplete="off"
                        disabled
                        className="inputFocus"
                        value={this.state.totalStock}
                        onChange={(event) =>
                          this.handleChange(event, "totalStock", "MaterialDetails")
                        }
                      />

                    </div>
                  </div>
                  <div className="btn-grp mt-3.5 mb-4">
                    {this.state.isMaterialDetailsEditing === true ? (
                      <button
                        className="add-btn"
                        disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                        onClick={() => this.addEditAdditionalEntryMaterialMapping()}
                      >
                        {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                      </button>
                    ) : (
                      <button
                        className="add-btn"
                        disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                        onClick={() => this.addEditAdditionalEntryMaterialMapping()}
                      >
                        {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                      </button>
                    )}
                    <button
                      disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                      className="cancel-btn"
                      // className={`${this.state.isMaterialDetailsHide ? "disable-button" : ""
                      //   } cancel-btn`}
                      onClick={() => this.resetMaterialDetalis()}
                    >
                      Cancel
                    </button>
                    <button
                      className="back-btn"
                      disabled={this.state.isLoading}
                      onClick={() => this.resetFormAndOpenGrid()}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
              <div className="innerTable">
                <div className="innerTable-container" style={{ height: "calc(100vh - 345px)" }}>
                  <table className="innerList">
                    <thead>
                      <tr>
                        <td style={{ width: "55%" }} >Material Name</td>
                        <td style={{ width: "15%" }}>Quantity</td>
                        <td style={{ width: "15%" }}>UOM</td>
                        <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                      </tr>
                    </thead>
                    {this.state.productionMaterialDetailsList && this.state.productionMaterialDetailsList.length > 0 ?
                      this.state.productionMaterialDetailsList.map((details, key) => (
                        <tbody key={key}>
                          <tr>
                            <td>{this.state.productionRequisitionEntry.materialType === 'Raw' ? details.rawMaterialId?.rmName : details.packageMaterialId?.pmName}</td>
                            <td>{details.qty}</td>
                            <td>{this.state.productionRequisitionEntry.materialType === 'Raw' ? details.rawMaterialId?.rmUOM : details.packageMaterialId?.pmUOM}</td>
                            <td style={{ textAlign: "center" }}>
                              <button
                                className="search-btn"
                                onClick={() => this.getMaterialDetailsById(details)}
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                              <button
                                className="cancel-btn"
                                onClick={() => this.deleteAdditionalEntryMaterialDetailsById(details._id)}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      )) :
                      null

                    }
                  </table>
                </div>
              </div>
              <div className="btn-grp">

              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default AdditionalEntry;